import { useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

function invalidateAll(qc) {
  qc.invalidateQueries({ queryKey: ['catalog', 'products'] });
  qc.invalidateQueries({ queryKey: ['catalog', 'categories'] });
}

export function useCreateProduct() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/catalog/products', body).then((r) => r.data),
    successMessage: 'تم إنشاء المنتج',
    onSuccess: () => invalidateAll(qc)
  });
}

export function useUpdateProduct() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, body }) => api.patch(`/catalog/products/${id}`, body).then((r) => r.data),
    successMessage: 'تم حفظ التعديلات',
    onSuccess: () => invalidateAll(qc)
  });
}

export function useDeleteProduct() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (id) => api.delete(`/catalog/products/${id}`).then((r) => r.data),
    successMessage: 'تم حذف المنتج',
    onSuccess: () => invalidateAll(qc)
  });
}

export function useImportProducts() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (items) => api.post('/catalog/products/import', items).then((r) => r.data),
    onSuccess: () => invalidateAll(qc)
  });
}
